import { Card, CardContent, CardHeader, Grid } from "@mui/material";

import React from "react";
import { useFormState } from "react-final-form";
import SARSEmployeeDetails from "./SARSEmployeeDetails";
import TaxpayerDetails from "./TaxpayerDetails";
import QuestionFieldToggle from "./usercomponents/QuestionFieldToggle";

const EnterFraudDetails = (_props) => {
  const formstate = useFormState();
  return (
    <Grid size={{ xs: 12 }}>
      <Grid size={{ xs: 12 }}>
        <Card>
          <SARSEmployeeDetails />
        </Card>
      </Grid>
      {/* ) : null} */}
      <Grid size={{ xs: 12 }}>
        <Card>
          <CardHeader title="Details of Reporter" />
          <CardContent>
            <QuestionFieldToggle
              name="q_contactdetails"
              label="May SARS contact you for further information?"
            />
          </CardContent>
        </Card>

        {formstate.values?.q_contactdetails === "yes" ? (
          <>
            <Card>
              <TaxpayerDetails />
            </Card>
          </>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default EnterFraudDetails;
